import {lazy} from 'react';
import {useSelector} from 'react-redux';
import parseHTML from 'html-react-parser';
import {selectTerms, selectUserOrSystemDisabled} from '~/common/fabric/GiftCard/reducers/eGiftCard';
import {Typography} from '~library/atoms/Typography';

import './Review.sass';

const EventReview = lazy(() =>
  import('~/common/fabric/routes/EventReview/EventReview').then((module) => ({
    default: module.EventReview,
  }))
);

export const Review = () => {
  const isGiftCard = !useSelector(selectUserOrSystemDisabled);
  const stripeKey = isGiftCard ? window.stripeElementPublishableKey : window.stripePublishableKey;
  const termsText = useSelector(selectTerms);
  const parsedTermsText = parseHTML(termsText ?? '');

  const terms = termsText ? (
    <Typography
      classNames="payment-method__disclosure"
      variant="paragraph4"
      data-qa-id="payment-method__disclosure"
      color="pebble"
    >
      {parsedTermsText}
    </Typography>
  ) : null;

  return (
    <EventReview
      navigateToRoute={undefined}
      useCurrentRoute={undefined}
      eventRepr={undefined}
      PreviewElementOverride={undefined}
      isProcessing={false}
      saveFn={undefined}
      stripeKey={stripeKey}
      terms={terms}
    />
  );
};
